import React from "react";

const PageTransition = (props) => {
  return (
    <main>
      <div className="transition-wrapper">
        <div className="loader">
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </div>
    </main>
  );
};

export default PageTransition;
